export const IPP_NA_LOCALES = ['en-US'] as const
export const IPP_EU_LOCALES = ['es-ES', 'fr-FR'] as const

/**
 * All supported IPP locales, composed of NA and EU locales.
 */
export const IPP_SUPPORTED_LOCALES = [...IPP_NA_LOCALES, ...IPP_EU_LOCALES] as const
export type IPP_SUPPORTED_LOCALE = 'en-US' | 'es-ES' | 'es-US' | 'fr-FR' | 'fr-CA'

export const IPP_DEFAULT_LOCALE: IPP_SUPPORTED_LOCALE = 'en-US'

/**
 * Translation catalog keys — one per distinct string payload a domain ships.
 * Regional variants collapse onto a base catalog (es-US reuses ES_ES, fr-CA reuses FR_FR).
 */
export type IPP_TRANSLATION_KEY = 'EN_US' | 'ES_ES' | 'FR_FR'

/**
 * Maps every supported locale to its catalog key. Exhaustive by construction: the
 * `Record<IPP_SUPPORTED_LOCALE, ...>` type forces an entry for each locale, so adding
 * a locale to IPP_SUPPORTED_LOCALE is a compile error until it is mapped here.
 */
export const LOCALE_TO_TRANSLATION_KEY: Record<IPP_SUPPORTED_LOCALE, IPP_TRANSLATION_KEY> = {
  'en-US': 'EN_US',
  'es-ES': 'ES_ES',
  'es-US': 'ES_ES',
  'fr-FR': 'FR_FR',
  'fr-CA': 'FR_FR',
}
